import * as Yup from 'yup';
import { CreateRecipientRequestPayloadType } from '@/api/v1/organization/vendor-vault/createRecipientRequestApi';
import { RequestModeType, RequestTypeType } from '@/types/vendorVaultTypes';

export type NewRequestFormType = CreateRecipientRequestPayloadType;

export const newRequestInitialValues = (requestType: RequestTypeType, mode: RequestModeType): NewRequestFormType => ({
  request_type: requestType,
  bank: null,
  recipient_name: '',
  mode,
  audience: 'recipient',
  via: 'email',
  sent_to: '',
  expiry_code: '7d',
  wire_confirmation: false,
  detailed: false,
});

export const newRequestValidationSchema = Yup.object({
  recipient_name: Yup.string().trim().required('Enter the recipient name.').max(255),
  bank: Yup.string()
    .nullable()
    .when('request_type', { is: 'intl', then: (s) => s.required('Choose the bank you will send from.') }),
  sent_to: Yup.string().when('via', {
    is: 'email',
    then: (s) => s.trim().email('That email address does not look right.').required('Enter an email address.'),
    otherwise: (s) =>
      s.when('via', {
        is: 'sms',
        then: (p) => p.trim().required('Enter a mobile number.'),
        otherwise: (p) => p.notRequired(),
      }),
  }),
});
